module.exports = __webpack_public_path__ + "static/colgadas-016-795f1c50de57cbd2b7e7f65e4845a719.jpg";